var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-11",
      class: [
        "q-field row no-wrap items-start q-field-floating q-field-no-label",
        _vm.mensagemErro ? "q-field-with-error col-11" : ""
      ],
      staticStyle: { "padding-right": "10px" }
    },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "q-field-content col-xs-12 col-sm" }, [
          _c(
            "div",
            {
              class: [
                "datepicker-valor",
                "q-if row no-wrap",
                "relative-position",
                "q-input",
                "q-if-has-label",
                _vm.mensagemErro ? "q-if-error" : "",
                _vm.desabilitar ? "q-if-disabled" : ""
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 q-if-inner col row no-wrap items-center relative-position",
                  staticStyle: { "margin-bottom": "0px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-datetime", {
                        attrs: {
                          "float-label": _vm.etiqueta,
                          format: _vm.formatoTexto,
                          disable: _vm.desabilitar,
                          "input-class": "col q-input-target g-datepicker",
                          min: _vm.dataMin,
                          max: _vm.dataMax
                        },
                        on: {
                          input: function($event) {
                            _vm.atualizarModelo($event)
                          }
                        },
                        model: {
                          value: _vm.data,
                          callback: function($$v) {
                            _vm.data = $$v
                          },
                          expression: "data"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-1 text-right" },
                    [
                      _c(
                        "q-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.data != null,
                              expression: "data != null"
                            }
                          ],
                          staticClass: "datepicker-botao",
                          attrs: {
                            disabled: _vm.desabilitar,
                            flat: "",
                            color: "black"
                          },
                          on: { click: _vm.limparData }
                        },
                        [
                          _c("q-icon", {
                            attrs: {
                              name: "close",
                              size: "20px",
                              disabled: _vm.desabilitar
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mensagemErro,
                  expression: "mensagemErro"
                }
              ],
              staticClass: "q-field-bottom row no-wrap"
            },
            [
              _c("div", { staticClass: "q-field-error col" }, [
                _vm._v(_vm._s(_vm.mensagemErro))
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }